<template>
    <div class="storeInfo">
        <el-form ref="form" :model="form" :rules="rules">
            <el-row>
                <div class="topTitle">{{form.storeName}}</div>
            </el-row>
            <el-row>
                <el-col :span="2"><div class="seize"></div></el-col>
                <el-col :span="22">
                    <label><span>门店名称</span></label>{{form.storeName}}
                </el-col>
            </el-row>
			      <el-row>
                <el-col :span="2"><div class="seize"></div></el-col>
                <el-col :span="22">
                    <label><span>门店地址</span></label>{{form.storeAddress}}
                </el-col>
            </el-row>
			      <el-row>
                <el-col :span="2"><div class="seize"></div></el-col>
                <el-col :span="22">
                    <label><span>营业时间</span></label>
                    <el-form-item v-if="editFlag" prop="duration" style="display:inline-block;margin-bottom:0">
                      <el-time-picker is-range v-model="form.duration" style="width:200px" format="HH:mm" value-format="HH:mm" range-separator="-" start-placeholder="开始时间" end-placeholder="结束时间" placeholder="选择营业时间"></el-time-picker>
                    </el-form-item>
                    <span v-else>{{form.shopHours}}</span>
                    <span class="edit" @click="editTime">修改</span>
                </el-col>
            </el-row>
			      <el-row>
                <el-col :span="2"><div class="seize"></div></el-col>
                <el-col :span="22">
                    <label><span>展示图片</span></label>
                    <el-upload
                      class="uploadLists"
                      ref='upload'
                      :action="uploadUrl"
                      list-type="picture-card"
                      :file-list="fileListData"
                      multiple
                      :limit="6"
                      accept='.jpg,.png,.jpeg,.gif'
                      :beforeUpload="beforeAvatarUpload"
                      :before-remove="beforeRemove"
                      :on-preview="handlePictureCardPreview"
                      :on-remove="handleRemove"
                      :on-exceed="handleExceed"
                      :onError="uploadError"
                      :onSuccess="uploadSuccess"
                      :on-change='addFile'
                      >
                    <i class="el-icon-plus"></i>
                    </el-upload>
                    <el-dialog :visible.sync="dialogVisible">
                    <img width="100%" :src="fileImg" alt="">
                    </el-dialog>
                    <div class="picNum"><b>{{fileLength}}</b>/6</div>
                    <div class="require">
                      <b>图片要求：</b>
                      <p>1. 请上传横版4：3比例的清晰图片，例如尺寸：1200*900px</p>
                      <p>2. 请上传至少一张图片，最多可上传六张图片</p>
                      <p>3. 照片要求格式为JPG/JPEG/GIF/PNG，大小不要超过2M</p>
                    </div>
                </el-col>
            </el-row>
        </el-form>
    </div>
</template>
<script>
import { storeInfo, updateStore, uploadUrl, deleteFiles } from "@/api";

export default {
  data() {
    return {
      form: {
        duration: [],
        files: []
      },
      editFlag: false,
      rules: {
        duration: [
          { required: true, message: '请选择营业时间', trigger: 'change'}
        ]
      },
      uploadUrl,
      fileListData: [],
      fileLength: 0,
      dialogVisible: false,
      fileImg: ""
    };
  },
  created() {
    this.detailInfo();
  },
  methods: {
    detailInfo() {
      storeInfo().then(res => {
        if (res.code == 1) {
          this.form = res.data;
          let fileImgs = [];
          for (let i of res.data.files) {
            fileImgs.push({
              id: i.id,
              url: i.file,
              name: i.fileName
            });
          }
          this.fileListData = fileImgs;
          this.fileLength = parseInt(this.fileListData.length);
        }
      });
    },
    editTime() {
      //   修改营业时间
      if (!this.editFlag) {
        this.editFlag = true;
        let curTime = this.form.shopHours ? this.form.shopHours.split('-'):'';
        this.$set(this.form,'duration',curTime);
        $(".edit").html("确定");
      } else {
        this.$refs.form.validate(valid => {
          if (valid) {
            updateStore({
              operateFlag: "1",
              shopHours: this.form.duration.join('-')
            }).then(res => {
              if (res.code == 1) {
                this.editFlag = false;
                $(".edit").html("修改");
                this.form.shopHours = this.form.duration.join('-');
              }
              this.$message({
                type: res.code == 1 ? "success" : "error",
                message: res.msg
              });
            });
          }
        });
      }
    },
    handleRemove(file, fileList) {
      const extension = file.name.split(".")[1] === "jpg";
      const extension1 = file.name.split(".")[1] === "png";
      const extension2 = file.name.split(".")[1] === "jpeg";
      const extension3 = file.name.split(".")[1] === "gif";
      if (!extension && !extension1 && !extension2 && !extension3) {
        return;
      } else {
        //   删除图片
        deleteFiles({
          // id: file.id
          file: file.response ? file.response.files[0].url : file.url
        }).then(res => {
          this.fileLength = fileList.length;
          this.$message({
            type: res.code == 1 ? "success" : "error",
            message: res.msg
          });
        });
      }
    },
    handlePictureCardPreview(file) {
      this.fileImg = file.url;
      this.dialogVisible = true;
    },
    handleExceed(files, fileList) {
      this.$message.warning(
        `当前限制选择 6 个文件，本次选择了 ${
          files.length
        } 个文件，共选择了 ${files.length + fileList.length} 个文件`
      );
    },
    beforeRemove(file, fileList) {
      const extension = file.name.split(".")[1] === "jpg";
      const extension1 = file.name.split(".")[1] === "png";
      const extension2 = file.name.split(".")[1] === "jpeg";
      const extension3 = file.name.split(".")[1] === "gif";
      if (!extension && !extension1 && !extension2 && !extension3) {
        return;
      } else {
        if (file) {
          return this.$confirm(`确定移除 ${file.name}？`);
        } else {
          let imgNames = file.response.data.files[0].name;
          return this.$confirm(`确定移除 ${imgNames}？`);
        }
      }
    },
    uploadSuccess(response, file, fileList) {
      // 上传成功后的回调
      //   this.fileUrl.push(response.obj[0]);
      this.form.files = [];
      this.form.files.push({
        file: response.files[0].url,
        fileName: response.files[0].name
      });
      updateStore({
        operateFlag: "4",
        files: this.form.files
      }).then(res => {
        if (res.code != 1) {
          this.$message({
            type: "error",
            message: res.msg
          });
        }
      });
    },
    uploadError(response, file, fileList) {
      // 上传错误
      this.$message({
        message: "上传失败，请重试！",
        type: "error"
      });
    },
    addFile(file, fileList) {
      const extension = file.name.split(".")[1] === "jpg";
      const extension1 = file.name.split(".")[1] === "png";
      const extension2 = file.name.split(".")[1] === "jpeg";
      const extension3 = file.name.split(".")[1] === "gif";
      const isLt2M = file.size / 1024 / 1024 < 2;
      if (
        (!extension && !extension1 && !extension2 && !extension3) ||
        !isLt2M
      ) {
        return;
      } else {
        this.fileLength = fileList.length;
      }
    },
    beforeAvatarUpload(file) {
      const extension = file.name.split(".")[1] === "jpg";
      const extension1 = file.name.split(".")[1] === "png";
      const extension2 = file.name.split(".")[1] === "jpeg";
      const extension3 = file.name.split(".")[1] === "gif";
      const isLt2M = file.size / 1024 / 1024 < 2;
      if (!extension && !extension1 && !extension2 && !extension3) {
        this.$message({
          message: "上传模板只能是 .jpg,.png,.jpeg,.gif 格式!",
          type: "error"
        });
      }
      if (!isLt2M) {
        this.$message.error("上传图片大小不能超过 2M!");
      }
      return (extension || extension1 || extension2 || extension3) && isLt2M;
    }
  }
};
</script>
<style lang="less" scoped>
.storeInfo {
  width: 100%;
  overflow: hidden;
  padding: 100px 50px 70px;
  position: relative;
  .el-row {
    margin-bottom: 28px;
  }
  label {
    width: 140px;
    text-align: right;
    display: inline-block;
    margin-right: 10px;
    span {
      min-width: 95px;
      height: 30px;
      line-height: 30px;
      text-align: center;
      display: inline-block;
      padding: 0 15px;
      background: #eff1f5;
      border-radius: 15px;
      color: #444;
    }
  }
  .seize {
    height: 20px;
  }
  .topTitle {
    font-size: 20px;
    font-weight: bold;
    text-align: center;
  }
  .uploadLists {
    display: inline-block;
  }
  .picNum {
    width: 72px;
    height: 28px;
    border: 1px solid #dee6ea;
    border-radius: 14px;
    margin: 15px 0 20px;
    text-align: center;
    line-height: 28px;
    margin-left: 150px;
  }
  .require {
    margin-left: 150px;
    line-height: 27px;
    color: #666;
  }
  .edit {
    background: url(../../assets/images/store/icon_edit.png) no-repeat left
      center;
    color: #f83b56;
    padding-left: 16px;
    cursor: pointer;
  }
}
</style>
<style lang="less">
.storeInfo {
  .el-upload-list__item-status-label {
    display: inline-block;
  }
  .el-range-separator{
    width: 26px;
  }
}
</style>





// WEBPACK FOOTER //
// src/components/basicDataCenter/storeBasicInfo.vue